module.exports = __webpack_public_path__ + "img/mobile-features-dapps.4d851223.svg";